import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, inject, input, Input, OnDestroy, OnInit, signal, ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CmsService, GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { first, Subscription } from 'rxjs';
import { ImageModalComponent } from '../../components/image-modal/image-modal.component';
import { CustomProfileAndPreferencesService } from '../../../custom-profile-and-preferences/custom-profile-and-preferences.service';
import { AddCardService } from './add-card.service';

@Component({
  selector: 'app-add-card',
  templateUrl: './add-card.component.html',
  styleUrls: ['./add-card.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddCardComponent implements OnInit, OnDestroy {
  private readonly modalService = inject(NgbModal);
  private readonly cdr = inject(ChangeDetectorRef);

  isProfilePage = input(false);
  forceDefaultPayment = input(false);

  protected readonly IMAGE_SRC = 'img/accountNumberInfo.jpg';
  url = 'https://angular.io/api/router/RouterLink';
  iframeHeight = input<number>(450);
  @Input() forCheckingAccounts = false;
  @Input() public isCheckout = false;
  urlSafe: SafeResourceUrl;
  iframeUrl: any;
  private loaded = false;

  accessTokenForIframe: any;
  iframeLoad = false;
  dummyUrl: SafeResourceUrl;
  pageId: string;
  @ViewChild('iframe') iframe: ElementRef;
  makeDefaultMethod = false;
  private cmsSub: Subscription;
  private elementCheck: ReturnType<typeof setTimeout>;

  constructor(
    private readonly pfService: CustomProfileAndPreferencesService,
    private readonly sanitizer: DomSanitizer,
    public activeModal: NgbActiveModal,
    private readonly globalMessage: GlobalMessageService,
    private readonly addCardService: AddCardService,
    protected cmsService: CmsService
  ) {
  }

  ngOnInit(): void {
    this.loaded = false;
    this.makeDefaultMethod = this.isProfilePage() ? this.forceDefaultPayment() : false;

    this.cmsSub = this.cmsService.getCurrentPage().subscribe((res) => {
      this.pageId = res?.pageId;
    });
  }

  ngAfterViewInit(): void {
    this.loadScript();
    this.pfService.getIframeUrl(this.forCheckingAccounts);
    this.pfService.iframeUrl.subscribe((data) => {
      this.accessTokenForIframe = data.accessToken;

      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
        data.iframeUrl
      );
      this.dummyUrl = data.iframeUrl;
      this.iframeLoad = true;
      this.cdr.detectChanges();
    });
  }

  loadScript(): void {
    if (!window.document.getElementById('payment')) {
      const script = window.document.createElement('script');
      script.id = 'payment';
      script.type = 'text/javascript';
      script.src = '../../scripts/payments.js';
      window.document.body.appendChild(script);
    }
  }

  onSubmitIFrame(): void {
    window['$XIFrame'].submit({
      iFrameId: 'valid-for-data',
      targetUrl: this.dummyUrl,
      autosizeheight: true,

      onSuccess: (msg) => {
        const message = JSON.parse(msg);
        if (message && message.data.HasPassed) {
          this.addCardService
            .addCard({
              accessToken: this.accessTokenForIframe,
              defaultPaymentInfo: this.isProfilePage() ? this.makeDefaultMethod : this.forceDefaultPayment(),
              savePaymentDetails: this.isProfilePage() ? true : this.makeDefaultMethod,
              ach: !!this.forCheckingAccounts,
            })
            .pipe(
              first(Boolean)
            )
            .subscribe({
              next: (res) => {
                if (res.addPaymentDetails === true) {
                  this.pfService.getAccountIdFromDb();

                  this.addCardService.cardAdded.next(res);
                  this.activeModal.close();

                  return;
                }

                this.onPaymentMethodError(res.errorMessage);
              },
              error: e => e.foreach(error => this.onPaymentMethodError(error.errorMessage))
            });
        }
      },
      onError: function (msg) {
        console.info(msg);
      }
    });
  }

  closeIframe(): void {
    if (this.pageId === 'MyAccountOpenInvoicePaymentPage') {
      this.addCardService.cardCloseError.next(true);
    }
  }

  ngOnDestroy(): void {
    this.addCardService.cardAdded.next(false);
    this.cmsSub?.unsubscribe();
    clearInterval(this.elementCheck);
  }

  open(): void {
    const modalRef = this.modalService.open(ImageModalComponent, { centered: true });
    modalRef.componentInstance.imageUrl = signal(this.IMAGE_SRC);
  }

  private onPaymentMethodError(message: string): void {
    this.activeModal.close();
    window.scroll(0, 0);
    this.globalMessage.add(message, GlobalMessageType.MSG_TYPE_ERROR);
  }
}
